<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;
        <li class="breadcrumb-item active">
          {{ (course$ | async)?.description }}
        </li>
      </ol>
    </nav>
    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">{{ (course$ | async)?.description }}</h1>
      <item-navigation
        class="ms-auto"
        [itemId]="courseId$ | async"
        [itemType]="navigationItemTypes.COURSE"
      ></item-navigation>
    </div>
  </header>

  <!-- Nav -->
  <div class="row">
    <div class="col-xl-3 mb-3 sidenav-custom-wrap">
      <!-- End Page Header -->
      <aside class="card navbar-vertical py-2 sidenav-custom">
        <!-- WCAG skip link -->
        <!-- <a
          href="#productContent"
          class="nav-link visually-hidden-focusable d-flex justify-content-center"
          ><span>{{ 'wcag.skipNavigation' | translate }}</span></a
        > -->
        <!-- END WCAG skip link -->
        <ul
          class="navbar-nav nav-tabs flex-row flex-md-wrap flex-xl-column"
          *ngIf="course$ | async as course"
          role="tablist"
        >
          <li class="nav-item" *ngIf="courseModuleConfig.fullAccess">
            <a
              [routerLink]="['/courses/', course.id, 'general']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
              role="tab"
              #rla1="routerLinkActive"
              [attr.aria-selected]="rla1.isActive ? 'true' : 'false'"
            >
              <i
                role="img"
                class="fa fa-cube fa-fw me-1"
                aria-hidden="true"
              ></i>
              {{ 'general.general' | translate }}
            </a>
          </li>
          <li class="nav-item" *ngIf="courseModuleConfig.fullAccess">
            <a
              class="nav-link"
              [routerLink]="['/courses', course.id]"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              role="tab"
              #rla2="routerLinkActive"
              [attr.aria-selected]="rla2.isActive ? 'true' : 'false'"
            >
              <i
                role="img"
                class="fa fa-fw me-1 fa-users"
                aria-hidden="true"
              ></i>
              {{ 'participationModule.participations' | translate }}
            </a>
          </li>
          <li
            class="nav-item"
            *ngIf="achievementModuleConfig.isActive"
          >
            <a
              class="nav-link"
              [routerLink]="['/courses', course.id, 'achievement']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              role="tab"
              #rla2="routerLinkActive"
              [attr.aria-selected]="rla2.isActive ? 'true' : 'false'"
            >
              <i
                role="img"
                class="fa fa-fw me-1 fa-star"
                aria-hidden="true"
              ></i>
              {{ 'achievements.achievements' | translate }}
            </a>
          </li>
          <li class="nav-item" *ngIf="courseModuleConfig.fullAccess">
            <a
              class="nav-link"
              [routerLink]="['/courses', course.id, 'communication']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              role="tab"
              #rla2="routerLinkActive"
              [attr.aria-selected]="rla2.isActive ? 'true' : 'false'"
            >
              <i
                role="img"
                class="fa fa-fw me-1 fa-comment"
                aria-hidden="true"
              ></i>
              {{ 'communicationModule.communication' | translate }}
            </a>
          </li>
          <li class="nav-item" *ngIf="courseModuleConfig.fullAccess">
            <a
              class="nav-link"
              [routerLink]="['/courses', course.id, 'activities']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              role="tab"
              #rla2="routerLinkActive"
              [attr.aria-selected]="rla2.isActive ? 'true' : 'false'"
            >
              <i
                role="img"
                class="fa fa-file me-1 fa-fw"
                aria-hidden="true"
              ></i>
              {{ 'activityModule.logs' | translate }}
            </a>
          </li>
          <li class="nav-item" *ngIf="courseModuleConfig.fullAccess">
            <a
              [routerLink]="['/courses', course.id, 'bookings']"
              (click)="setTitle('bookings')"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
              role="tab"
              #rla5="routerLinkActive"
              [attr.aria-selected]="rla5.isActive ? 'true' : 'false'"
            >
              <i
                role="img"
                class="fa fa-calendar-alt fa-fw me-1"
                aria-hidden="true"
              ></i>
              {{ 'bookingModule.bookings' | translate }}
            </a>
          </li>

          <li class="nav-item" *ngIf="courseModuleConfig.fullAccess">
            <a
              [routerLink]="['/courses', course.id, 'bookings', 'create']"
              (click)="setTitle('bookings')"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
              role="tab"
              #rla5="routerLinkActive"
              [attr.aria-selected]="rla5.isActive ? 'true' : 'false'"
            >
              <i
                role="img"
                class="fa fa-calendar-plus fa-fw me-1"
                aria-hidden="true"
              ></i>
              {{ 'bookingModule.createBookings' | translate }}
            </a>
          </li>
        </ul>
        <!-- End Nav -->
      </aside>
    </div>
    <div class="col-xl" id="productContent">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
